import { Typography, Row, Col, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f8f6f0',
      fontFamily: 'Georgia, serif'
    }}>
      {/* Header */}
      <div style={{ 
        textAlign: 'center', 
        padding: '40px 20px 20px',
        background: '#f8f6f0'
      }}>
        <Title level={1} style={{ 
          color: '#fca600', 
          margin: 0, 
          fontWeight: 'normal',
          fontSize: 'clamp(32px, 6vw, 48px)',
          letterSpacing: '2px',
          textTransform: 'uppercase',
          marginBottom: '8px',
          fontFamily: 'Mont, sans-serif'
        }}>
          Festivals Malta Portal
        </Title>
      </div>

      {/* Hero Section */}
      <div style={{
        height: '400px',
        backgroundImage: 'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url("https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        margin: '20px 40px',
        borderRadius: '8px'
      }}>
        <div style={{ textAlign: 'center', color: 'white', zIndex: 2 }}>
          <Title level={2} style={{ 
            color: 'white', 
            marginBottom: '16px',
            fontWeight: 'normal',
            fontSize: 'clamp(24px, 5vw, 40px)',
            fontFamily: 'Mont, sans-serif'
          }}>
            Celebrating the Past, Creating the Future
          </Title>
        </div>
      </div>

      {/* Main Content Sections */}
      <div style={{ 
        padding: '60px 40px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <Row gutter={[60, 60]} align="stretch" justify="center">
          {/* For Employees Section */}
          <Col xs={24} md={12}>
            <div style={{ marginBottom: '40px', display: 'flex', flexDirection: 'column', height: '100%', alignItems: 'center', textAlign: 'center' }}>
              <Title level={2} style={{ 
                color: '#fca600', 
                fontSize: '32px',
                fontWeight: 'normal',
                marginBottom: '20px',
                fontFamily: 'Mont, sans-serif',
                width: '100%'
              }}>
                For Employees
              </Title>
              <Text style={{ 
                color: '#666', 
                fontSize: '16px',
                lineHeight: '1.6',
                display: 'block',
                marginBottom: '30px',
                flex: 1,
                width: '100%'
              }}>
                Access your employee dashboard to manage applications, handle direct orders, and process overtime requests.
              </Text>

              <Button 
                type="primary"
                size="large"
                onClick={() => navigate('/login')}
                style={{
                  backgroundColor: '#fca600',
                  borderColor: '#fca600',
                  height: '45px',
                  fontSize: '14px',
                  fontWeight: 'normal',
                  borderRadius: '4px',
                  textTransform: 'uppercase',
                  letterSpacing: '1px'
                }}
              >
                Access Employee Portal
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LandingPage;